import styled from "styled-components";
import { prop, ifProp, theme } from "styled-tools";
import { handleSizeType } from "../../Utilities/Sizes";
import { handleColor } from "../../Utilities/Icons";

export const TextStyled = styled.p<{
  $size: number;
  color?: string;
  weight?: number;
  align?: string;
  margin?: string;
}>`
  color: ${(props) =>
    props.color ? handleColor(props.color) : theme("White")};
  font-family: "Montserrat";
  font-weight: ${ifProp("weight", prop("weight"), "400")};
  // It can improve with styled tools, for the moment it's fine.
  font-size: ${(props) => (props.$size ? handleSizeType(props.$size) : "16px")};
  text-align: ${ifProp("align", prop("align"), "center")};
  margin: ${prop("margin")};
`;
